export default __webpack_public_path__ + "ce2941e6c3ea07d990541620f24d7199.svg";